import React, { useEffect } from 'react'
import { useLegalFieldsTemplate } from 'common/hooks/useLegalFieldsTemplate'
import { Link } from 'react-router-dom'
import { kebabCase } from 'lodash'
interface LegalFieldsProps {
  area: string
}
const LegalFields = ({ area }: LegalFieldsProps) => {
  const { legalSubFields, loadLegalSubFields } = useLegalFieldsTemplate()
  useEffect(() => {
    loadLegalSubFields(area)
  }, [area])

  return (
    <div className='w-full mb-28 md:pb-0'>
      <div className='px-2.5 sm:px-4 md:px-6 lg:px-10 xl:px-16 2xl:px-20 box-border'>
        <div className='flex justify-center md:justify-end flex-wrap w-full max-w-[670px] space-x-2 md:space-x-3 md:ml-auto'>
          {legalSubFields.map((legalSubField) => (
            <Link
              to={`/legal-sub-field/${kebabCase(legalSubField.master_term)}`}
              className='bg-white text-xs sm-text-sm md:text-base leading-5 font-medium text-[#1C7D93] tracking-wide rounded-md shadow-md pt-2 pb-2 pl-3 pr-3 mb-3'
              key={legalSubField.master_term}
            >
              {legalSubField.master_term}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default LegalFields
